<template>
  <div>
    <v-row no-gutters class="mb-5">
      <v-col cols="12">
        <h1 class="headline font-weight-light mb-3">
          Engineer Update
          <v-chip
            class="ml-2"
            color="teal"
            small
            outlined
            v-if="role_name != 'Admin'"
            @click="
              (date = new Date().toISOString().substr(0, 10)),
                get_zonehistory(1),
                (dialoghistory = true),
                (form_searchhistory.emp_id = '')
            "
          >
            <v-avatar left>
              <v-icon small>mdi-history</v-icon>
            </v-avatar>
            history
          </v-chip>
        </h1>
      </v-col>
    </v-row>
    <template>
      <!-- v-if="status != ''" -->
      <v-row class="mt-7">
        <v-col cols="5" md="4" lg="3">
          <v-select
            class="pr-3"
            :items="data_zone"
            v-model="form_search.branch_id"
            item-text="branch_name"
            item-value="branch_id"
            outlined
            dense
            clearable
            @change="get_engineer()"
          >
            <template v-slot:label>
              <v-icon small class="mb-1" style="vertical-align: middle">
                mdi-filter
              </v-icon>
              Filter Zone
            </template>
          </v-select>
        </v-col>
        <v-col cols="5" md="4" lg="3">
          <v-select
            class="pr-3"
            :items="data_project"
            v-model="form_search.project_id"
            item-text="project_name"
            item-value="project_id"
            outlined
            dense
            clearable
            @change="get_engineer()"
          >
            <template v-slot:label>
              <v-icon small class="mb-1" style="vertical-align: middle">
                mdi-filter
              </v-icon>
              Filter Project
            </template>
          </v-select>
        </v-col>
        <v-col cols="5" md="4" lg="3" v-if="form_search.branch_id != 0">
          <v-progress-linear
            indeterminate
            color="cyan"
            class="mt-10"
            v-if="
              form_search.branch_id !== undefined &&
                form_search.engineer &&
                form_search.engineer.length == 0
            "
          ></v-progress-linear>
          <v-select
            v-if="form_search.engineer && form_search.engineer.length > 0"
            class="pr-3"
            :items="form_search.engineer"
            v-model="form_search.emp_id"
            item-text="emp_name_en"
            item-value="emp_id"
            menu-props="auto"
            outlined
            dense
            clearable
            @change="
              get_data(1, 'selectall'),
                get_summary(
                  form_search.branch_id,
                  'all',
                  form_search.emp_id,
                  form_search.project_id
                )
            "
          >
            <template v-slot:label>
              <v-icon small class="mb-1" style="vertical-align: middle">
                mdi-filter
              </v-icon>
              Filter Engineer
            </template>
          </v-select>
        </v-col>

        <v-col cols="1">
          <v-btn
            x-small
            fab
            v-if="
              (form_search.branch_id != 0 &&
                form_search.branch_id !== undefined) ||
                form_search.emp_id != ''
            "
            @click="reset()"
          >
            <v-icon>mdi-rotate-left</v-icon></v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3" class="cur-p">
          <v-card @click="change_statusall">
            <v-list-item two-line>
              <v-list-item-content>
                <b style="font-size:15px;">All</b>
              </v-list-item-content>
              <v-btn
                elevation="0"
                fab
                dark
                small
                :color="
                  chk_active_all === 1 ? 'teal accent-3' : 'grey lighten-1'
                "
                >{{ all_sum }}</v-btn
              >
            </v-list-item>
            <v-system-bar
              :height="4"
              dark
              :color="chk_active_all === 1 ? 'teal accent-3' : 'white'"
            >
            </v-system-bar>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="cur-p"
          v-for="(rowSum, indexSum) in data_sum"
          :key="indexSum"
        >
          <v-card @click="change_status(indexSum, rowSum.status)">
            <v-list-item two-line>
              <v-list-item-content>
                <b style="font-size:15px;">{{ rowSum.status }}</b>
              </v-list-item-content>
              <v-btn
                elevation="0"
                fab
                dark
                small
                :color="
                  indexSum === chk_active_btn
                    ? 'teal accent-3'
                    : 'grey lighten-1'
                "
                >{{ rowSum.num_rows }}</v-btn
              >
            </v-list-item>
            <v-system-bar
              :height="4"
              dark
              :color="indexSum === chk_active_btn ? 'teal accent-3' : 'white'"
            >
            </v-system-bar>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-row>
      <v-col cols="12">
        <v-simple-table class="table-inv">
          <template v-slot:default>
            <thead>
              <tr class="col-tr-1">
                <th class="text-center">
                  #
                </th>
                <th class="text-center">
                  Case
                </th>
                <th class="text-center">
                  WO
                </th>
                <th class="text-center">
                  Site Name
                </th>
                <th class="text-center">
                  Zone / CE
                </th>
                <th class="text-center">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="6" v-if="data_main && data_main.length === 0">
                  <v-progress-linear
                    indeterminate
                    color="cyan"
                  ></v-progress-linear>
                </td>
              </tr>
              <tr
                v-if="
                  data_main && data_main.length === 0 && chk_load_data != true
                "
              >
                <td colspan="6" class="text-center">
                  no results found
                </td>
              </tr>

              <tr v-for="(row, index) in data_main.data" :key="index">
                <td class="text-center">
                  {{ index + 1 + (data_main.current_page - 1) * 20 }}.
                </td>
                <td class="text-center">
                  <v-btn @click="get_modal(row.maincase_id)" rounded small
                    >{{ row.case_id }} - {{ row.subcase }}</v-btn
                  >
                </td>
                <td>{{ row.wonumber }}</td>
                <td>{{ row.site_name }}</td>
                <td>
                  <b>{{ row.branch_name }}</b
                  ><br />{{ row.engineer_name }}
                </td>
                <td>{{ row.status }}</td>
              </tr>
              <br />
            </tbody>
          </template>
        </v-simple-table>

        <v-pagination
          v-model="show_page"
          :length="data_main.last_page"
          circle
          :total-visible="7"
          @input="get_data(show_page)"
        ></v-pagination>
      </v-col>
    </v-row>

    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{
                data_case.case_id + " - " + data_case.subcase
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="save()">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list three-line subheader>
              <v-list-item>
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12">
                      <b>Case Title : </b>
                      <span class="fix-color">{{ data_case.case_title }}</span>
                    </v-col>
                    <v-col ccols="12" sm="6">
                      <b>Case ID : </b>
                      <span class="fix-color">{{
                        data_case.case_id + " - " + data_case.subcase
                      }}</span>
                      <v-chip
                        @click="doCopy()"
                        small
                        class="ml-2 mr-2 mb-2 success"
                      >
                        <v-avatar left>
                          <v-icon small color="white"
                            >mdi-clipboard-file-outline</v-icon
                          > </v-avatar
                        ><label style="color:white;">Copy Case ID</label>
                      </v-chip>

                      <ViewCdax caseid:caseid />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <b>WO Number : </b>
                      <span class="fix-color">{{ data_case.wonumber }}</span>
                      <v-chip
                        @click="doCopyWO()"
                        small
                        class="ml-2 mr-2 mb-2 success"
                      >
                        <v-avatar left>
                          <v-icon small color="white"
                            >mdi-clipboard-file-outline</v-icon
                          > </v-avatar
                        ><label style="color:white;">Copy WO Number</label>
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <b>Engineer Update Status : </b>
                      <span class="fix-color">{{
                        data_case.ce_update_status
                      }}</span>
                      |
                      <b>Schedule Range : </b
                      ><span class="fix-color">{{
                        data_case.schedule_range
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <b>Onsite Date : </b
                      ><span class="fix-color">{{
                        data_case.onsite_date
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6"
                      ><b>Engineer : </b>
                      <span class="fix-color">{{
                        data_case.branch_name + " / " + data_case.engineer_name
                      }}</span></v-col
                    >
                    <v-col cols="12" sm="6">
                      <b>Site Name : </b>
                      <span class="fix-color">{{
                        data_case.site_name
                      }}</span></v-col
                    >

                    <v-col
                      cols="12"
                      v-if="
                        data_case.ce_update_status !== 'Cannot Contact Customer'
                      "
                    >
                      <v-row>
                        <v-col cols="12" sm="6"
                          ><b>Customer Name: </b
                          ><span class="fix-color">{{
                            data_case.customer_name
                          }}</span>
                        </v-col>

                        <v-col cols="12" sm="6"
                          ><b>Customer Tel : </b
                          ><span class="fix-color">{{
                            data_case.customer_tel
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-else>
                      <v-row>
                        <v-col cols="6" sm="3">
                          <v-text-field
                            outlined
                            dense
                            v-model="data_case.customer_name"
                            label="Customer Name"
                            :rules="[(v) => !!v || 'Customer Name is required']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <v-text-field
                            outlined
                            dense
                            v-model="data_case.customer_tel"
                            label="Customer Tel"
                            :rules="[(v) => !!v || 'Customer Tel is required']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-text-field
                            outlined
                            dense
                            v-model="data_case.remark"
                            label="Remark"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        outlined
                        readonly
                        v-model="data_case.lognote"
                        label="Lognote..."
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-textarea
                        outlined
                        readonly
                        v-model="data_case.cdax_log"
                        label="CDAX Log..."
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6" class="mar-t-30">
                      <v-textarea
                        outlined
                        v-model="text_copy"
                        label="Auto Log..."
                      ></v-textarea>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            style="margin-right:-15px; margin-top:-50px; float:right;"
                            small
                            v-on="on"
                            color="blue lighten-1"
                            fab
                            @click="doCopyLog()"
                          >
                            <v-icon color="white">mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copy Log</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" align-self="end"> </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-row justify="center">
      <v-dialog
        v-model="dialoghistory"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar fixed dark color="primary" data-v-f3f3eg9>
            <v-btn icon dark @click="dialoghistory = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title
              >History

              <!-- <v-chip class="ml-2" color="white" light dense>
                <strong></strong>
              </v-chip> -->
            </v-toolbar-title>
          </v-app-bar>

          <v-timeline dense class="mt-12 pt-12 pr-12">
            <v-timeline-item color="teal" fill-dot small>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted"
                        label="Date"
                        :rules="notdate"
                        required
                        persistent-hint
                        prepend-icon="mdi-calendar-month"
                        v-bind="attrs"
                        @blur="date = parseDate(dateFormatted)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" lg="3">
                  <v-select
                    class="pt-4"
                    :items="data_zonehistory"
                    v-model="form_searchhistory.branch_id"
                    item-text="branch_name"
                    item-value="branch_id"
                    :rules="notzone"
                    required
                    outlined
                    dense
                    multiple
                    @change="get_engineerhistory(), selectzonefilter()"
                  >
                    <template v-slot:label>
                      <v-icon small class="mb-1" style="vertical-align: middle">
                        mdi-filter
                      </v-icon>
                      Filter Zone
                    </template>
                    <template
                      v-slot:selection="{
                        item,
                        index,
                      }"
                    >
                      <v-chip v-if="index === 0">
                        <span>{{ item.branch_name }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{
                          form_searchhistory.branch_id.length - 1
                        }}
                        others)</span
                      >
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle()">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              form_searchhistory.branch_id.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                            >{{ form_searchhistory.icon }}</v-icon
                          >
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            Select All
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" lg="3" style="margin-top:15px;">
                  <v-select
                    v-if="
                      form_searchhistory.engineer &&
                        form_searchhistory.engineer.length > 0
                    "
                    class="pr-3"
                    :items="form_searchhistory.engineer"
                    v-model="form_searchhistory.emp_id"
                    item-text="emp_name_en"
                    item-value="emp_id"
                    menu-props="auto"
                    outlined
                    dense
                    clearable
                    @change="get_datahistory()"
                  >
                    <template v-slot:label>
                      <v-icon small class="mb-1" style="vertical-align: middle">
                        mdi-filter
                      </v-icon>
                      Filter Engineer
                    </template>
                  </v-select></v-col
                >
                <v-col cols="12" v-if="data_mainhistory.length == 0">
                  <v-progress-linear
                    indeterminate
                    color="cyan"
                  ></v-progress-linear>
                </v-col>
              </v-row>
              <div
                v-for="(datamainhistory, idx1) in data_mainhistory"
                :key="idx1"
              >
                <v-row>
                  <v-col md="12">
                    <h3 v-if="datamainhistory.onsite.length > 0">
                      {{ datamainhistory.branch_name }} (
                      {{ datamainhistory.emp_name_en }}
                      {{ datamainhistory.emp_surname_en }}
                      ) HPI :
                      {{ getHPIAmount(datamainhistory.onsite) }}
                      Cases | NONHP :
                      {{ getNONHPAmount(datamainhistory.onsite) }}
                      Cases
                    </h3>
                    <h3 v-else>
                      {{ datamainhistory.branch_name }} (
                      {{ datamainhistory.emp_name_en }}
                      {{ datamainhistory.emp_surname_en }}
                      )
                    </h3>
                  </v-col>
                </v-row>

                <v-simple-table
                  class="table-inv"
                  cellpadding="0"
                  cellspacing="0"
                >
                  <thead>
                    <tr class="col-tr-1">
                      <th class="text-center white--text">
                        Log Date
                      </th>

                      <th class="text-center white--text">
                        Case
                      </th>
                      <th class="text-center white--text">
                        Date
                      </th>
                      <th class="text-center white--text">
                        Product
                      </th>
                      <th class="text-center white--text">
                        Site Name
                      </th>

                      <th class="text-center white--text">
                        Ce Log Status
                      </th>
                      <th class="text-center white--text">
                        Remark
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="datamainhistory.onsite.length > 0">
                    <tr
                      v-for="(datamainhistoryonsite,
                      idx1) in datamainhistory.onsite"
                      :key="idx1"
                    >
                      <td>
                        {{ datamainhistoryonsite.log_date }}
                      </td>
                      <td>
                        <v-chip x-small>
                          {{ datamainhistoryonsite.project_name }}</v-chip
                        >
                        <v-chip x-small class="amber">
                          {{
                            datamainhistoryonsite.case_id +
                              "-" +
                              datamainhistoryonsite.subcase
                          }}
                        </v-chip>
                        <br />{{ datamainhistoryonsite.wonumber }}
                      </td>
                      <td class="text-center">
                        <v-chip x-small v-if="datamainhistoryonsite.open_date">
                          {{ "Open : " + datamainhistoryonsite.open_date }}
                        </v-chip>
                        <v-chip
                          x-small
                          class="mt-1"
                          color="primary"
                          v-if="datamainhistoryonsite.ship_date"
                        >
                          {{ "Ship : " + datamainhistoryonsite.ship_date }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip
                          x-small
                          v-if="datamainhistoryonsite.case_type"
                          >{{ datamainhistoryonsite.case_type }}</v-chip
                        >

                        <v-chip x-small class="mt-1" color="green lighten-3">
                          <span
                            class="mr-1"
                            v-if="datamainhistoryonsite.product_group"
                            >{{ datamainhistoryonsite.product_group }}</span
                          >
                          <span
                            v-if="datamainhistoryonsite.problem_type_name"
                            >{{ datamainhistoryonsite.problem_type_name }}</span
                          >
                        </v-chip>
                      </td>
                      <td>
                        {{ datamainhistoryonsite.site_name }}
                        <br />
                        <span v-if="datamainhistoryonsite.site_amphur_id">{{
                          datamainhistoryonsite.site_amphur_id
                        }}</span>
                        <span
                          class="mr-1"
                          v-if="datamainhistoryonsite.site_province_id"
                          >{{ datamainhistoryonsite.site_province_id }}</span
                        >
                      </td>

                      <td>
                        {{ datamainhistoryonsite.ce_log_status }}
                      </td>
                      <td>
                        {{ datamainhistoryonsite.remark }}
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-else>
                    <tr>
                      <td colspan="5" align="center">
                        No Case
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- snackbar -->
    <div id="snackbar" class="d-print-none">
      <v-snackbar v-model="snackbar" color="success" right>
        {{ text }}
      </v-snackbar>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import ViewCdax from "../../../components/ViewCdax";

import CustomerInformation from "./CustomerInformation";

const url = `${process.env.VUE_APP_ROOT_API}/api/`;

export default {
  computed: {
    ...mapState(["snackbar"]),
    ...mapState(["isLoading"]),
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    // dateRangeText() {
    //   this.dates.sort((a, b) => {
    //     return new Date(a) - new Date(b);
    //   });

    //   return this.dates.join(" ~ ");
    // },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.get_datahistory();
    },
  },

  beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
  },
  mounted() {
    this.get_zone();
    this.get_summary();
    this.get_data(1, "selectall");
  },
  components: {
    ViewCdax,
    customerinformation: CustomerInformation,
  },
  methods: {
    ...mapMutations(["mutatesnackbar"]),
    ...mapMutations(["mutateIsLoading"]),
    getHPIAmount(cases) {
      let filter = cases.filter((each) => {
        // console.log(each.project_name)
        return (
          each.project_name == "CDAX" ||
          each.project_name == "S-Print" ||
          each.project_name == "SRFR"
        );
      });
      // console.log(filter)
      return filter.length;
    },
    getNONHPAmount(cases) {
      let filter = cases.filter((each) => {
        // console.log(each.project_name)
        return (
          each.project_name != "CDAX" &&
          each.project_name != "S-Print" &&
          each.project_name != "SRFR"
        );
      });
      // console.log(filter)
      return filter.length;
    },
    selectzonefilter() {
      if (
        this.form_searchhistory.branch_id.length ===
        this.data_zonehistory.length
      ) {
        this.form_searchhistory.icon = "mdi-close-box";
      }
    },
    toggle() {
      if (
        this.form_searchhistory.branch_id.length !==
        this.data_zonehistory.length
      ) {
        this.form_searchhistory.icon = "mdi-close-box";
        this.form_searchhistory.branch_id = [];
        for (let a = 0; a < this.data_zonehistory.length; a++) {
          this.form_searchhistory.branch_id.push(
            this.data_zonehistory[a].branch_id
          );

          this.form_searchhistory.engineer = [];
        }
      } else {
        this.form_searchhistory.icon = "mdi-checkbox-blank-outline";
        this.form_searchhistory.branch_id = [];
        this.form_searchhistory.engineer = [];
      }
      setTimeout(() => {
        this.get_engineerhistory();
      }, 1000);
    },
    toggledefault() {
      this.form_searchhistory.icon = "mdi-close-box";
      this.form_searchhistory.branch_id = [];
      for (let a = 0; a < this.data_zonehistory.length; a++) {
        this.form_searchhistory.branch_id.push(
          this.data_zonehistory[a].branch_id
        );
        this.form_searchhistory.engineer = [];
      }
    },
    async get_engineerhistory() {
      this.form_searchhistory.emp_id = "";
      this.form_searchhistory.engineer = [];
      // this.show_page = 1;
      // this.get_data(1);
      // this.get_summary(this.form_search.branch_id, "all");
      // this.data_main = [];

      if (this.form_searchhistory.branch_id.length == 1) {
        await axios
          .get(
            url + "ce-update/get-ce/" + this.form_searchhistory.branch_id,
            this.tk
          )
          .then((response) => {
            this.form_searchhistory.engineer = response.data.engineer;
          })
          .catch((error) => {
            console.log(error);
          });
      }

      this.get_datahistory();
    },
    async get_zonehistory(test) {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      let url = `${process.env.VUE_APP_ROOT_API}/api/ce-update/get-zone`;
      await axios.get(url, options).then((response) => {
        this.data_zonehistory = response.data.zone;
      });
      if (test !== undefined) {
        this.toggledefault();
      }
      this.get_datahistory();
    },
    async get_datahistory() {
      this.data_mainhistory = [];
      if (
        this.form_searchhistory.branch_id != "" &&
        this.form_searchhistory.branch_id != undefined
      ) {
        try {
          let { data } = await axios.post(
            url + "ce-update/view-history",
            {
              date: this.date,
              branch_id: this.form_searchhistory.branch_id,
              engineer: this.form_searchhistory.emp_id,
            },
            this.tk
          );
          this.data_mainhistory = data;
        } catch (error) {
          console.log(error);
        }
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async get_summary(selectbranch, selectall, selectengineer, selectproject) {
      if (selectbranch == undefined) {
        selectbranch = "";
      }
      if (selectengineer == undefined) {
        selectengineer = "";
      }
      if (selectproject == undefined) {
        selectproject = "";
      }
      if (selectall == "all") {
        this.chk_active_all = 1;
        this.change_statusall();
      }
      this.mutateIsLoading();
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };

      try {
        let { data } = await axios.post(
          url + "ce-update/summary",
          {
            branch_id: selectbranch,
            project_id: selectproject,
            engineer: selectengineer,
          },
          options
        );

        this.data_sum = [];
        this.all_sum = 0;
        data["summary"].map((each) => {
          this.data_sum.push(Object.assign({}, each));
          this.all_sum += parseInt(each.num_rows);
        });

        this.mutateIsLoading();
      } catch (error) {
        this.mutateIsLoading();
        console.log(error);
      }
    },
    change_statusall() {
      this.show_page = 1;

      this.data_main = [];
      this.chk_load_data = false;
      this.chk_active_all = 1;
      this.chk_active_btn = null;
      this.status = "";
      this.get_data(1, "");
    },
    change_status(i, statusx) {
      this.show_page = 1;

      this.status = statusx;
      this.chk_active_all = null;
      this.chk_active_btn = i;
      this.data_main = [];
      this.chk_load_data = false;
      this.get_data(1);
    },
    async get_zone() {
      this.show_page = 1;

      this.get_data(1);
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      let url = `${process.env.VUE_APP_ROOT_API}/api/ce-update/get-zone`;
      await axios.get(url, options).then((response) => {
        this.data_zone = response.data.zone;
        this.data_project = response.data.project;
      });
    },
    async get_engineer() {
      this.form_search.emp_id = "";
      this.form_search.engineer = [];
      this.show_page = 1;
      this.get_data(1);
      this.get_summary(
        this.form_search.branch_id,
        "all",
        "",
        this.form_search.project_id
      );
      this.data_main = [];

      await axios
        .get(url + "ce-update/get-ce/" + this.form_search.branch_id, this.tk)
        .then((response) => {
          this.form_search.engineer = response.data.engineer;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async get_data(num, select) {
      this.data_main = [];
      this.chk_load_data = true;
      if (select == "selectall") {
        this.chk_active_all = 1;
        this.chk_active_btn = null;
      }
      try {
        let { data } = await axios.post(
          url + "ce-update/view-all?page=" + num,
          {
            branch_id: this.form_search.branch_id,
            emp_id: this.form_search.emp_id,
            status: this.status,
            project_id: this.form_search.project_id,
          },
          this.tk
        );

        this.data_main = data;
      } catch (error) {
        console.log(error);
      }
    },
    reset() {
      this.data_main = [];
      this.form_search.branch_id = "";
      this.form_search.emp_id = "";
      this.chk_load_data = false;
      this.status = "";
      this.get_summary(this.form_search.branch_id, "all");
      this.get_data(1);
    },
    async get_modal(maincase_id) {
      this.maincase_id = maincase_id;
      this.dialog = true;
      this.mutateIsLoading();
      await axios
        .get(url + "ce-update/view-case/" + maincase_id, this.tk)
        .then((response) => {
          this.data_case = response.data;
          this.text_copy = response.data.autolog;
          this.caseid = response.data.caseid;
          this.mutateIsLoading();
        })
        .catch((error) => {
          this.mutateIsLoading();
          console.log(error);
        });
    },
    doCopy() {
      navigator.clipboard.writeText(this.data_case.case_id);
    },
    doCopyWO() {
      navigator.clipboard.writeText(this.data_case.wonumber);
    },
    doCopyLog: function() {
      navigator.clipboard.writeText(this.text_copy);
      setTimeout(() => {
        this.showTooltip = !this.showTooltip;
      }, 500);
      setTimeout(() => {
        this.showTooltip = false;
      }, 2000);
    },
    close() {
      // this.data_main = []
      this.data_case = [];
      this.text_copy = "";
      this.maincase_id = 0;
      this.caseid = 0;
      this.dialog = false;
    },
    async save() {
      this.mutateIsLoading();

      let data_post = {
        customer_name: this.data_case.customer_name,
        customer_tel: this.data_case.customer_tel,
        remark: "",
        autolog: this.text_copy,
      };
      let data_postremark = {
        customer_name: this.data_case.customer_name,
        customer_tel: this.data_case.customer_tel,
        remark: this.data_case.remark,
        autolog: this.text_copy,
      };
      if (this.data_case.remark !== undefined) {
        await axios
          .post(
            url + "ce-update/save/" + this.maincase_id,
            data_postremark,
            this.tk
          )
          .then((response) => {
            this.get_summary(
              this.form_search.branch_id,
              this.status,
              this.form_search.emp_id,
              this.form_search.project_id
            );
            this.get_data(1);
            this.close();
            this.mutateIsLoading();
            this.mutatesnackbar();
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          })
          .catch((error) => {
            this.mutateIsLoading();
            console.log(error);
          });
      } else {
        await axios
          .post(url + "ce-update/save/" + this.maincase_id, data_post, this.tk)
          .then((response) => {
            this.get_summary(
              this.form_search.branch_id,
              this.status,
              this.form_search.emp_id,
              this.form_search.project_id
            );
            this.get_data(1);
            this.close();
            this.mutateIsLoading();
            this.mutatesnackbar();
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          })
          .catch((error) => {
            this.mutateIsLoading();
            console.log(error);
          });
      }
    },
  },

  data() {
    return {
      notdate: [(v) => v.length > 0 || "Date is required"],
      notzone: [(v) => v.length > 0 || "Zone is required"],
      form_searchhistory: {
        branch_id: [],

        zone: [],
        engineer: [],
        emp_id: "",
        icon: "mdi-checkbox-blank-outline",
      },

      data_mainhistory: [],
      data_zonehistory: [],
      data_project: [],
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu: false,
      // dates: [
      //   new Date().toISOString().substr(0, 10),
      //   new Date().toISOString().substr(0, 10),
      // ],
      dialoghistory: false,
      team_name: localStorage.team_name,
      role_name: localStorage.role_name,
      show_page: 1,
      dialog: false,
      data_sum: [],
      all_sum: 0,
      data_main: [],
      data_case: [],
      data_zone: [],
      text: "Success, Your work has been saved",
      tk: "",
      status: "",
      chk_active_all: null,
      chk_active_btn: null,
      chk_load_data: false,
      showTooltip: false,
      text_copy: "",
      maincase_id: 0,
      caseid: 0,
      form_search: {
        branch_id: 0,
        project_id: 0,
        zone: [],
        engineer: [],
        emp_id: "",
      },
    };
  },
};
</script>
<style scoped>
.fix-color {
  color: rgb(11, 53, 131) !important;
}
</style>
